export default "__VITE_ASSET__BI_yRlZE__"